import React from 'react';
import './UserTraining.scss';
import request from '../../utils/agent';
import UserStore from 'components/UserStore';

/**
 * Training Module loading
 * @param {string} module - Takes the `:module` param and passes it to the iframe src. Matches folder name in /public
 */

export default class UserTraining extends React.Component {
    constructor(props) {
        super(props);

        // Load our UserStore data
        this.userData = UserStore.get();
    }

    componentDidMount() {
        // The quiz is looking for this function, create and bind to our function
        // so we can pass through the data
        window['EducationModuleSendscore'] = this.handleSendScore;
    }

    handleSendScore = (success, percent) => {
        // TODO: This is currently failing with a 401
        request
            .put('/api/training')
            .send({
                user_id: this.userData.id, // This is my current ID, hard coded.
                success: !!success, //Enforce boolean
                percent: parseInt(percent),
                course_id: 1 // Unsure how we would figure this out
            })
            .then(resp => {
                // Original code has it just to back to the dashboard
                if(resp && resp.status === 200) {
                    window.dispatchEvent(new Event('trainingCompleted'));
                    console.log('completed');
                    window.location.replace('/user/dashboard');
                } else {
                    // Have them re-take the test?
                }
            })
            .catch(err => {
                // We could retry it or just let the user know something went wrong
            });
    }

    render() {

        let module = null;
        try {
            module = this.props.match.params.module;
        } catch(e) { /* In case the props fail to pass through */ }

        return (
            <section className='module--container'>
                <h1>Available Training</h1>

                <iframe src={`/elearning/${module}/index.html`} />
            </section>
        )
    }

};


// WEBPACK FOOTER //
// ./src/routes/UserTraining/module.js